// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"41":"a1cc0950","142":"eebfdaee","385":"c8c7930e","542":"5ded5070","557":"823b2334","828":"c5249e0b"}[chunkId] + ".js";
};